import { Fragment, VFC } from "react";
// Utils
import { useFilteredSellerListings, useInfinitePagination } from "hooks";
// Components
import { SellerListingCard } from "./SellerListingCard";
import { Button, Flex, NoItemsFound, Spacer, Text } from "components";

export const SellerListings: VFC = () => {
  const { listings, loading, quantity } = useFilteredSellerListings();
  const isOriginalLoading = !quantity && loading;

  const { visible, revealMore } = useInfinitePagination();

  return (
    <>
      {isOriginalLoading && !quantity && <Text>Loading</Text>}

      {!isOriginalLoading && !quantity && <NoItemsFound title="No listings found." />}

      {listings?.map((listing, listingIndex) => {
        if (listingIndex >= visible) return;

        if (!listing) return;

        return (
          <Fragment key={`listing_${listing.id}`}>
            <SellerListingCard listing={listing} />

            <Spacer baselineHeight={1} />
          </Fragment>
        );
      })}

      {quantity > visible && (
        <>
          <Spacer baselineHeight={2} />

          <Flex container containerJustifyContent="center">
            <Button caption="Load more" onClick={revealMore} />
          </Flex>
        </>
      )}
    </>
  );
};
